import { WaterAccountManagement } from '@models/waterAccount.model'
import { LodashUtils } from '@utils/lodash'
import { RootState } from './store'

export const selectedAccountSelector = (state: RootState) => {
  const { accountList, accountSelected } = state.waterAccount
  return LodashUtils.find(accountList, (o) => {
    if (accountSelected.isMerged) {
      return LodashUtils.isEqual(
        o.mergedWaterAccountId,
        accountSelected.mergedId,
      )
    }
    return LodashUtils.isEqual(o.accountNumber, accountSelected.contractNumber)
  })
}

export const getWaterAccountDetailsSelector = (state: RootState) => {
  return state.waterAccount.waterAccountDetails || []
}
export const getTerminatedWASelector = (state: RootState) => {
  return state.waterAccount?.terminatedWA || []
}
export const getEligibleWASelector = (state: RootState) => {
  return state.waterAccount.eligibleWA || []
}
export const isTerminatedAccountSelector = (state: RootState) => {
  return (
    LodashUtils.get(
      state.waterAccount.currentWaterAccount,
      'validationStatus',
      1,
    ) === 2
  )
}

export const isBusinessAccountSelector = (state: RootState) => {
  const selectedAccount = selectedAccountSelector(state)
  return LodashUtils.get(selectedAccount, 'isBusinessAccount', false)
}

export const isLimitedAccessPermission = (state: RootState) => {
  const selectedAccount = selectedAccountSelector(state)
  return (
    LodashUtils.get(
      selectedAccount,
      'userPermission',
      WaterAccountManagement.ACCOUNT_PERMISSION.LIMITED_ACCESS,
    ) === WaterAccountManagement.ACCOUNT_PERMISSION.LIMITED_ACCESS
  )
}

export const isAuthenticatedSelected = (state: RootState) =>
  !!LodashUtils.get(state, 'auth.auth', null)

// announcement
export const isHasAnnouncementSelector = (state: RootState) =>
  !LodashUtils.isEmpty(state.announcement.announcementList)

// configuration
export const isAppInstallAbleSelector = (state: RootState) =>
  LodashUtils.get(state, 'config.isAppInstallAble', false)
export const isAppInstalledSelector = (state: RootState) =>
  LodashUtils.get(state, 'config.isAppInstalled', false)
export const isNewUserSelector = (state: RootState) =>
  LodashUtils.get(state, 'auth.auth.isNewUser', false)
export const isEnableATHButtonSelector = (state: RootState) =>
  isAppInstallAbleSelector(state) || !isAppInstalledSelector(state)
export const getMyInfoSelector = (state: RootState) => {
  return LodashUtils.get(state, 'myInfo', {})
}
export const getReactiveInfoSelector = (state: RootState) => {
  return LodashUtils.get(state, 'onboarding.eligibleAuthMethods[0]', {})
}
export const getOnboardingSelector = (state: RootState) => {
  return LodashUtils.get(state, 'onboarding', {})
}